var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.9995,
    cy: 54.9995,
    r: 54.9995,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.9995,
    cy: 54.9995,
    r: 54.9995,
    fill: "#9B83CB",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.4516 71.2581V44.1613C77.4516 42.0268 75.7151 40.2903 73.5806 40.2903H63.5161V33.3226C63.5161 32.0421 62.4741 31 61.1935 31H41.0645C39.784 31 38.7419 32.0421 38.7419 33.3226V40.2903H36.4194C34.2849 40.2903 32.5484 42.0268 32.5484 44.1613V71.2581H31V75.129C31 77.2635 32.7365 79 34.871 79H75.129C77.2635 79 79 77.2635 79 75.129V71.2581H77.4516ZM73.5806 41.8387C74.8612 41.8387 75.9032 42.8808 75.9032 44.1613V71.2581H74.3548V44.9355C74.3548 44.0815 73.6604 43.3871 72.8064 43.3871H63.5161V41.8387H73.5806ZM48.0323 72.8064H61.9677V73.5806C61.9677 74.008 61.6201 74.3548 61.1935 74.3548H48.8065C48.3799 74.3548 48.0323 74.008 48.0323 73.5806V72.8064ZM37.1935 71.2581V44.9355H38.7419V45.7097C38.7419 46.9902 39.784 48.0323 41.0645 48.0323H46.6248C46.5373 48.2785 46.4839 48.537 46.4839 48.8065V61.1935C46.4839 62.4741 47.5259 63.5161 48.8065 63.5161H55.7742V68.0103L62.9641 63.5161H68.9355C70.216 63.5161 71.2581 62.4741 71.2581 61.1935V48.8065C71.2581 47.5259 70.216 46.4839 68.9355 46.4839H63.3737C63.4604 46.2408 63.5161 45.9822 63.5161 45.7097V44.9355H72.8064V71.2581H37.1935ZM68.9355 48.0323C69.3621 48.0323 69.7097 48.3791 69.7097 48.8065V61.1935C69.7097 61.6209 69.3621 61.9677 68.9355 61.9677H62.5197L57.3226 65.2155V61.9677H48.8065C48.3799 61.9677 48.0323 61.6209 48.0323 61.1935V48.8065C48.0323 48.7592 48.0508 48.7166 48.0586 48.6717L54.2258 52.5265V48.0323H60.4689H61.1935H68.9355ZM40.2903 33.3226C40.2903 32.8952 40.6379 32.5484 41.0645 32.5484H61.1935C61.6201 32.5484 61.9677 32.8952 61.9677 33.3226V45.7097C61.9677 46.137 61.6201 46.4839 61.1935 46.4839H60.4689H52.6774V49.7316L47.4803 46.4839H41.0645C40.6379 46.4839 40.2903 46.137 40.2903 45.7097V33.3226ZM34.0968 44.1613C34.0968 42.8808 35.1388 41.8387 36.4194 41.8387H38.7419V43.3871H37.1935C36.3396 43.3871 35.6452 44.0815 35.6452 44.9355V71.2581H34.0968V44.1613ZM77.4516 75.129C77.4516 76.4095 76.4095 77.4516 75.129 77.4516H34.871C33.5905 77.4516 32.5484 76.4095 32.5484 75.129V72.8064H46.4839V73.5806C46.4839 74.8612 47.5259 75.9032 48.8065 75.9032H61.1935C62.4741 75.9032 63.5161 74.8612 63.5161 73.5806V72.8064H77.4516V75.129Z",
    fill: "#9B83CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1919 74.3564H35.6436V75.9048H37.1919V74.3564Z",
    fill: "#9B83CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2889 74.3564H38.7405V75.9048H40.2889V74.3564Z",
    fill: "#9B83CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3846 74.3564H41.8362V75.9048H43.3846V74.3564Z",
    fill: "#9B83CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4168 34.0957H41.8362V35.6441H60.4168V34.0957Z",
    fill: "#9B83CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4168 37.1925H41.8362V38.7409H60.4168V37.1925Z",
    fill: "#9B83CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4241 40.2882H58.8757V41.8366H60.4241V40.2882Z",
    fill: "#9B83CB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3201 40.2882H41.8362V41.8366H57.3201V40.2882Z",
    fill: "#9B83CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9048 43.385H50.3564V44.9334H51.9048V43.385Z",
    fill: "#9B83CB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5484 43.385H55V44.9334H56.5484V43.385Z",
    fill: "#9B83CB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2601 43.385H45.7117V44.9334H47.2601V43.385Z",
    fill: "#9B83CB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1659 49.5764H55.7788V51.1248H68.1659V49.5764Z",
    fill: "#9B83CB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1659 52.6732H55.7788V54.2216H68.1659V52.6732Z",
    fill: "#9B83CB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1634 55.7789H66.615V57.3273H68.1634V55.7789Z",
    fill: "#9B83CB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0603 55.7789H49.5764V57.3273H65.0603V55.7789Z",
    fill: "#9B83CB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6441 58.8756H58.0957V60.424H59.6441V58.8756Z",
    fill: "#9B83CB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2889 58.8756H62.7405V60.424H64.2889V58.8756Z",
    fill: "#9B83CB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0005 58.8756H53.4521V60.424H55.0005V58.8756Z",
    fill: "#9B83CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.20a0edaf9a19b2ab83a22865d2e9207d.svg";
export { ForwardRef as ReactComponent };